import { render, staticRenderFns } from "./TheNoRecordOfMarriage.vue?vue&type=template&id=5436f305&"
import script from "./TheNoRecordOfMarriage.vue?vue&type=script&lang=js&"
export * from "./TheNoRecordOfMarriage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports